// extracted by mini-css-extract-plugin
export var backdropBlur = "_e5-0";
export var contentCard = "_e5-5";
export var frame = "_e5-2";
export var image = "_e5-4";
export var imagePane = "_e5-3";
export var modal = "_e5-1";